import React, { cloneElement } from "react";
import {
  Button,
  Datagrid,
  Filter,
  ResourceContextProvider,
  RowClickFunction,
  sanitizeListRestProps,
  SearchInput,
  ShowProps,
  TextField,
  TopToolbar,
  useListContext,
} from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import IconPlus from "@material-ui/icons/Add";
import { GetParam } from "utils/tools";
import CustomDateField from "components/CustomDateField";
import { PaddingDenseStyled2List } from "../../components/ListWrapper";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const ListActions = (props: any) => {
  const param = GetParam();
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      <Button
        onClick={() =>
          history.push(
            `/ccaAcademicTerms/create?source=${JSON.stringify({
              ccaAcademicYearId: Number(props.filterValues?.CcaAcademicYearId),
            })}&schoolId=${param.get("schoolId")}&ccaAcademicYearId=${
              props.filterValues?.CcaAcademicYearId
            }`
          )
        }
        label="Create Term"
      >
        <IconPlus />
      </Button>
    </TopToolbar>
  );
};

const AcademicTerm = (props: ShowProps) => {
  const param = GetParam();

  const rowClick: RowClickFunction = (id, basePath, record) =>
    `/ccaAcademicTerms/${id}?schoolId=${param.get(
      "schoolId"
    )}&ccaAcademicYearId=${props.id}`;

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Academic Terms</Typography>
      </Grid>

      <Grid item xs={12}>
        <ResourceContextProvider value="ccaAcademicTerms">
          <PaddingDenseStyled2List
            {...props}
            exporter={false}
            hasCreate={false}
            filters={<ThisFilter />}
            filterDefaultValues={{ CcaAcademicYearId: Number(props.id) }}
            bulkActionButtons={false}
            title=" "
            actions={<ListActions history={props.history} />}
          >
            <Datagrid rowClick={rowClick}>
              <TextField source="name" label="Term" />
              <CustomDateField source="startDate" label="From" />
              <CustomDateField source="endDate" label="To" />
            </Datagrid>
          </PaddingDenseStyled2List>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default AcademicTerm;
